import React from "react";
import type { Project } from "../../../api/useProjects";
import t from "../../../i18n";
import useModal from "@ui/lib/hooks/useModal";
import Button from "@ui/Button";
import Modal from "@ui/Modal";
import PatchSnapshotsModalForm from "../../Sources/PatchSnapshotsModalForm";
import { useCanUserDoOnProject } from "../../canUserDo";
import { UploadLine } from "@ui/IconV2/react";

interface ImportSnapshotActionProps {
  project: Project;
}

export const ImportSnapshotAction = ({ project }: ImportSnapshotActionProps) => {
  const canImportSnapshot = useCanUserDoOnProject("PROJECT_WRITE", project.id);
  const { openModal, closeModal, modal: isModalOpen } = useModal();
  if (!canImportSnapshot) return null;

  return (
    <>
      <Button variant="secondary" slim type="button" leftIcon={<UploadLine />} onClick={openModal}>
        {t("sources.button.import")}
      </Button>
      <Modal title={t("sources.button.import")} isOpen={isModalOpen} onRequestClose={closeModal}>
        <PatchSnapshotsModalForm
          onRequestClose={closeModal}
          project={project}
          onSourceUpdated={null}
          openCreateProjectModal={null}
        />
      </Modal>
    </>
  );
};
